import { render, staticRenderFns } from "./Git.vue?vue&type=template&id=8e3d2a26&scoped=true&"
import script from "./Git.vue?vue&type=script&lang=js&"
export * from "./Git.vue?vue&type=script&lang=js&"
import style0 from "./Git.vue?vue&type=style&index=0&id=8e3d2a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3d2a26",
  null
  
)

export default component.exports